// extracted by mini-css-extract-plugin
export default {"details":"HsLnkWLI","adress":"epTroAyJ","mobile":"mobile","captionWrapper":"ptCylRhm"};